const Marker = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="21"
      viewBox="0 0 14 21"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#4F4335" fillRule="nonzero">
          <g>
            <g>
              <g>
                <path
                  d="M7 .01C3.144.01.008 3.148.008 7.004c0 4.483 5.967 11.765 6.22 12.072l.772.936.771-.936c.254-.308 6.221-7.59 6.221-12.072C13.992 3.147 10.856.01 7 .01zm0 2c2.753 0 4.992 2.24 4.992 4.994 0 2.705-3.114 7.357-4.992 9.822-1.878-2.463-4.992-7.113-4.992-9.822C2.008 4.25 4.247 2.01 7 2.01zM7 4.5C5.619 4.5 4.5 5.619 4.5 7S5.619 9.5 7 9.5 9.5 8.381 9.5 7 8.381 4.5 7 4.5z"
                  transform="translate(-736 -655) translate(165 294) translate(534 123) translate(37 238)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export { Marker };
